import React, { useEffect, useState } from 'react'
import { IconButton, Toolbar as MuiToolbar, Tooltip } from '@mui/material'
import { Share, PictureAsPdf } from '@mui/icons-material'
import Translate from '../translate'
import clsx from 'clsx'
import { useStyles } from './style'
import ToolbarRecommend from '../toolbar-recommend'
import MoreActions from '../more-actions'
import { UserGroupPolicy } from '../../user-group-policy'
import {
  ALLOW_TRANSLATE_GROUP,
  ALLOW_DOWNLOADS_GROUP
} from '../../user-group-policy/permissions'
import { useDispatch, useSelector } from 'react-redux'
import { contentSlice } from '../../../reducers'
import { useAddToBookmarks } from '../../add-to-bookmarks'

const variants = {
  inline: ['share', 'pdf', 'translate'],
  vertical: ['translate', 'share', 'pdf', 'like', 'more'],
  floating: ['like', 'share', 'pdf', 'more', 'translate']
}

const Toolbar = props => {
  const {
    variant = 'inline',
    className,
    handleAddToPlaylist
  } = props
  const classes = useStyles(props)
  const content = useSelector(contentSlice.selectors.selectContent)
  const onAddToPlaylist = () => handleAddToPlaylist(content)
  const [bookmarksContent, setBookmarksContent] = useState([])
  const onBookmark = () => handleBookmark(content)
  const { isBookmarked, handleBookmark } = useAddToBookmarks(bookmarksContent)
  const bookmarked = isBookmarked(content)
  const dispatch = useDispatch()
  const { actions: { showModal } } = contentSlice
  const onTranslate = () => dispatch(showModal('translate'))
  const onDownload = () => dispatch(showModal('pdf'))
  const onShare = () => dispatch(showModal('share'))
  const language = useSelector(contentSlice.selectors.selectLanguage)

  useEffect(() => {
    if (content) {
      setBookmarksContent([content])
    }
  }, [content])

  const actions = {
    like: (
      <ToolbarRecommend key='like' />
    ),
    share: (
      <Tooltip
        title='Share this article'
        key='share'
        PopperProps={{ 'data-test': 'article-share-tooltip' }}
      >
        <IconButton onClick={onShare} data-test='article-share' size='large'>
          <Share />
        </IconButton>
      </Tooltip>
    ),
    pdf: (
      <UserGroupPolicy
        accessGroup={ALLOW_DOWNLOADS_GROUP}
        key='pdf'
        componentAllow={
          <Tooltip
            title='Download this article'
            key='pdf-tooltip'
            PopperProps={{ 'data-test': 'article-pdf-tooltip' }}
          >
            <IconButton onClick={onDownload} data-test='article-pdf' size='large'>
              <PictureAsPdf />
            </IconButton>
          </Tooltip>
        }
      />
    ),
    translate: (
      <UserGroupPolicy
        accessGroup={ALLOW_TRANSLATE_GROUP}
        key='translate'
        componentAllow={
          <Translate
            onClick={onTranslate}
            name={language.translatedLabel}
            key='translate'
            className={classes.lang}
            classes={{ button: classes.translateIcon }}
          />
        }
      />
    ),
    more: (
      <Tooltip
        title='More actions'
        key='more'
        PopperProps={{ 'data-test': 'article-more-tooltip' }}
      >
        <MoreActions
          onAddToPlaylist={onAddToPlaylist}
          onBookmark={onBookmark}
          bookmarked={bookmarked}
        />
      </Tooltip>
    )
  }

  const renderActions = () => {
    const order = variants[variant]
    return order.map(name => actions[name])
  }

  return (
    <MuiToolbar
      disableGutters
      className={clsx(classes.root, className)}
      data-test='article-toolbar'
    >
      {renderActions()}
    </MuiToolbar>
  )
}

export default Toolbar
